import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { LeadForm } from "../components/LeadForm";

const CARD_IMG = "https://images.unsplash.com/photo-1725793558251-2723d6e21efe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

const steps = [
  "Book a same-day evaluation with a licensed Utah provider",
  "We handle your state registry paperwork end-to-end",
  "Walk out a verified patient — ready to shop the pharmacy",
  "Get automatic renewal reminders so your card never lapses",
];

export default function MedicalCard() {
  return (
    <main data-testid="medical-card-page" className="pt-28 pb-24">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <div className="text-xs tracking-[0.2em] uppercase font-bold text-honey mb-6">Utah Medical Cannabis Card</div>
            <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
              className="font-display font-extrabold uppercase text-5xl md:text-7xl tracking-tighter leading-[0.88] mb-8">
              Get Your<br /><span className="text-honey">Card.</span>
            </motion.h1>
            <p className="text-stone text-lg leading-relaxed mb-10 max-w-md">
              Becoming a Utah medical cannabis patient is easier than you think. Our pharmacist-led team guides you
              from evaluation to your first pickup — often the same day.
            </p>

            <div className="aspect-[16/10] overflow-hidden mb-10">
              <img src={CARD_IMG} alt="Utah" className="w-full h-full object-cover" />
            </div>

            <ul className="space-y-5">
              {steps.map((s, i) => (
                <motion.li key={i} initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }} transition={{ delay: i * 0.08 }}
                  className="flex gap-4 items-start">
                  <CheckCircle2 className="text-honey shrink-0 mt-0.5" size={22} />
                  <span className="text-bone/90 text-lg">{s}</span>
                </motion.li>
              ))}
            </ul>
          </div>

          <div className="bg-ink2 border border-bone/10 p-8 lg:p-12 lg:sticky lg:top-28">
            <h2 className="font-display font-bold text-3xl mb-2">Request a Consultation</h2>
            <p className="text-stone mb-10">No obligation. A BeeHive pharmacist will reach out within one business day.</p>
            <LeadForm kind="medical_card" cta="Book My Evaluation" />
            <div className="mt-10 pt-8 border-t border-bone/10">
              <p className="text-stone text-sm mb-4">Already a patient?</p>
              <Link to="/menu" className="inline-flex items-center gap-2 text-honey uppercase tracking-widest text-sm">
                Shop the Menu <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
